import React from 'react';

/**
 * Shared utility for rendering AI-generated markdown-style text consistently.
 * - Section headings (**Heading**:) render as bold, primary, uppercase, tracking-wide
 * - All ** markers stripped from body text
 * - Numbered items and bullet points properly indented
 */

export function renderAILines(text) {
  if (!text) return null;
  return text.split('\n').map((line, i) => {
    const stripped = line.trim();
    if (!stripped) return null;

    // Section headings: **Heading** or **Heading**: or **Heading** (extra):
    const headingMatch = stripped.match(/^\*\*(.+?)\*\*\s*(\(.*?\))?\s*:?(.*)/);
    if (headingMatch && stripped.startsWith('**')) {
      const heading = headingMatch[1] + (headingMatch[2] ? ' ' + headingMatch[2] : '');
      const rest = (headingMatch[3] || '').trim().replace(/\*\*/g, '');
      return (
        <div key={i} className="mt-4 mb-2 first:mt-0">
          <h4 className="text-sm font-bold text-primary uppercase tracking-wide">{heading}</h4>
          {rest && <p className="mt-1 text-sm">{rest}</p>}
        </div>
      );
    }

    // Clean remaining ** markers
    const clean = stripped.replace(/\*\*/g, '');

    // Bullet or numbered items
    if (/^[-*]\s/.test(stripped) || /^\d+[\).\s]/.test(stripped)) {
      return <p key={i} className="ml-4 mb-1 text-sm">{clean}</p>;
    }

    return <p key={i} className="mb-2 text-sm">{clean}</p>;
  });
}

/** Strip ** markers from a string */
export function cleanMarkdown(text) {
  return (text || '').replace(/\*\*/g, '');
}
